export default {
  root: {
    position: 'relative',
    '& a': {
      position: 'absolute',
      top: 37,
      left: 'calc(100%)',
      '& svg': {
        fill: '#df0000'
      }
    }
  },
  inputWrapper: {
    display: 'flex',
    alignItems: 'center',
    '& > label': {
      flex: 1
    }
  },
  display: {
    alignItems: 'center',
    backgroundColor: ({ displayText, color, background }) => (displayText ? background : color),
    border: ({ borderColor }) => (borderColor ? `1px solid ${borderColor}` : undefined),
    borderRadius: ({ borderRadius }) => borderRadius,
    color: ({ color }) => color,
    display: 'flex',
    fontSize: ({ fontSize }) => fontSize,
    fontWeight: ({ fontWeight }) => fontWeight,
    height: 34,
    justifyContent: 'center',
    marginTop: 19,
    textDecoration: ({ textDecoration }) => textDecoration,
    width: 34,
    pointerEvents: 'none'
  }
};
